import { memo } from "react";
import { ThemeColors } from "~/styles/theme.type";

type RootStylesType = {
  themeColors: ThemeColors;
  fontFamily: string;
};

const RootStyles = (theme: RootStylesType) => {
  return (
    <style
      id='global-styles'
      type='text/css'
      dangerouslySetInnerHTML={{
        __html: `
				:root{
					--button-color: ${theme.themeColors.button};
					--contrasting-color: ${theme.themeColors.text};
					--background-color: ${theme.themeColors.background};
          --background-color-highlight: color-mix(in srgb, var(--button-color), transparent 85%);
					--font-family: ${theme.fontFamily};
				}
		`,
      }}
    />
  );
};
export default memo(RootStyles);
